<template>
  <div class="home">
    <div class="top">宁波象山绿城喜来登酒店</div >
    <div class="topbanner"></div>
    <div class="homeContent">
     <div class="indexContent" v-show="tabactive==1">
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'active':openbaseInfo==true }" >
            <span class="tit"  @click="openSth('openbaseInfo')">酒店基本信息</span>
          <ul class="baseInfo" v-if="openbaseInfo==true">
            <li><span class="title">酒店全称：</span> <span>宁波象山绿城喜来登度假酒店</span></li>
            <li><span class="title">法人姓名：</span> <span>王军</span></li>
            <li><span class="title">经营地址：</span> <span>浙江省宁波市象山县亚帆路88号</span></li>
            <li><span class="title">社会信用代码：</span> <span>91330225MA7BGGE189</span></li>
            <li><span class="title">卫生许可证号：</span> <span>330225-000251</span></li>
            <li><span class="title">许可证有效期限：</span> <span>2022/06/22 - 2026/06/21</span></li>
            <li><span class="title">量化等级：</span> <span>C级</span></li>
          </ul>
         </div>
        </div>
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'activeHealthSystem':openHealthSystem==true }" >
            <span class="tit"  @click="openSth('openHealthSystem')">酒店卫生制度</span>
            <div class="HealthSystem"  v-if="openHealthSystem==true">
              <div class="title" style="margin-bottom: 5px;">本酒店严格执行以下制度</div>
              <el-scrollbar >
                <div class="text"  >
                <span>1.公共场所的法人代表（负责人）是其经营场所卫生安全的第一责任人。</span> <br/>
                <span>2.公共场所从业人员须进行健康检查（每年一次）、接受卫生知识培训，取得健康合格证明且培训考核合格后方可上岗；要保持良好的个人卫生，操作时穿戴整洁的工作衣帽。 </span> <br/>
                <span>3.公共场所室内空气质量、微小气候、水质、采光、照明、顾
           客用品用具及集中空调通风系统等每年须不少于一次的卫生检测，检
测结果符合国家卫生标准、要求；反复使用的公共用品用具一客一换
一消毒。</span> <br/>
                <span>4.公共场所经营者须根据规模、项目设置清洁、消毒、保洁、
盥洗等设施设备和公共卫生间，并保持正常运行。</span> <br/> 
                <span>5.公共场所消毒间须独立密闭设置，要配备足够数量的消毒设
施和消毒设备，且运转正常；消毒程序符合要求，消毒记录及时规范。 </span> <br/>
<span>6.公共场所须配备安全、有效的预防控制蚊、蝇、蟑螂、鼠和
其他病媒生物的设施设备及废弃物存放专用设施设备。 </span> <br/> 
 <span>7.公共场所经营者采购洗化用品、消毒产品等公共卫生用品时
须索取检验合格证明和其他相关资料，并建立台账。 </span> <br/> 
 <span>8.公共场所经营者须制定公共场所危害事故应急预案（方案），
发生危害健康事故的应当立即处置，并及时向卫生行政部门报告。 </span> <br/>
<span>9.室内公共场所禁止吸烟。室内须有醒目的禁止吸烟警语和标
志，有专（兼）职人员对吸烟者进行劝阻。 </span> <br/>
<span>10.公共场所经营者须在经营场所醒目位置公示公共场所卫生许
可证、公共场所信誉度等级及卫生检测结果。 </span> <br/>
              </div>
</el-scrollbar>
             
            </div>
         </div>
        </div>
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'active':openDetectionRecords==true }" >
            <span class="tit"  @click="openSth('openDetectionRecords')">酒店检测记录</span>
            <div class="DetectionRecords"  v-if="openDetectionRecords==true">
              <div class="title"><span>时间</span><span>内容</span><span>详情</span></div>
              <div class="table" @click="$router.push('/airpdf') ">
                <span><i>2023-07</i> <i>集中空调检测记录</i> <i class="sj"></i></span>
              </div>
              <div class="table" @click="$router.push('/waterpdf') ">
                <span><i>2023-07</i> <i>二次供水检测记录</i> <i class="sj"></i></span>
              </div>
            </div>
         </div>
        </div>
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'active':openEmployeeInfo==true }"  >
            <span class="tit" @click="openSth('openEmployeeInfo')">员工体检信息</span>
            <div class="EmployeeInfo"  v-if="openEmployeeInfo==true">
              <div class="EmployeeInfotop">
                <div class="box"><span class="num">25</span><span class="title">从业人员数量</span></div>
                <div class="box"><span class="num">25</span><span class="title">健康证获取数量</span></div>
                <div class="box"><span class="num">100%</span><span class="title">健康证获取率</span></div>
              </div>
              <div class="table">
                <div class="item">
            <el-table :data="tableData" border height="130" style="font-size: 12px;">
              <el-table-column prop="name" label="姓名" width="40" >
              </el-table-column>
              <el-table-column prop="ep" label="岗位" width="70">
              </el-table-column>
              <el-table-column prop="number" label="健康证号" width="120">
              </el-table-column>
              <el-table-column prop="time" label="发证时间" >
              </el-table-column>
            </el-table>
          </div>

              </div>
              
            </div>
         </div>
        </div>
     </div>
     <div class="roomContent" v-show="tabactive==2">
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'active':openbcInfo==true }" >
            <span class="tit"  @click="openroomSth('openbcInfo')">布草更换智能监管</span>
          <div class="bcInfo" v-if="openbcInfo==true">
            <div class="bctop"><img src="~@/assets/nb/bucao.png" alt=""></div>
            <div class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;将RFID标签熨烫在酒店布草上，通过RFID读卡器记录布草的流转状态，主要是脏布草的送出、干净布草的送回。布草保洁，以及干净布草在房间内的铺设。酒店掌握布草的全流程状态，并可以向住客开放，提高入住满意度。酒店可以减少布草的人工清点，节约人力成本。同时酒店可以对布草的寿命做到精确管控。</div>
          </div>
         </div>
        </div>
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'active':opencupInfo==true }" >
            <span class="tit"  @click="openroomSth('opencupInfo')">杯具清洗智能监管 </span>
            <div class="cupInfo"  v-if="opencupInfo==true">
            <div class="cuptop"><img src="~@/assets/nb/cup.png" alt=""></div>
            <div class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在酒店杯具消毒间安装摄像头，自动采集保洁人员的工作记录。同时无线智能插座监控消毒柜的工作状态。系统平台对保洁人员的工作记录和消毒柜的工作记录进行分析，得出此洗消间是否进行了合规洗消的结论。</div>
            </div>
         </div>
        </div>
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'active':openjjInfo==true }" >
            <span class="tit"  @click="openroomSth('openjjInfo')">洁具清洗智能监管</span>
            <div class="jjInfo"  v-if="openjjInfo==true">
              <div class="jjtop"><img src="~@/assets/nb/jieju.png" alt=""></div>
             <div class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;将RFID标签贴在马桶、台盆和浴缸等洁具上，同时也贴在各自的抹布上。打扫的时候佩戴手环式读卡器。读卡器能同时读到洁具上的标签和抹布上的标签，设备能判断抹布和洁具是否匹配，并出相应的提醒，同时将打扫记录上报到平台。</div>
            </div>
         </div>
        </div>
        <div class="hotelTit"> 
          <div class="titleBar" :class="{ 'activeroomClearn':openroomInfo==true }"  >
            <span class="tit" @click="openroomSth('openroomInfo')">客房保洁详情查询</span>
            <div class="roomInfo"  v-if="openroomInfo==true">
              <div class="search">
                <div class="left">
                 <span></span>
                 <input type="text" placeholder="请输入房间号查询" v-model="roomId" > 
                </div>
                <div class="right" @click="getRoomInfo">
                  查询
                </div>
              </div>
              <div class="item">
                <p><i></i>保洁信息</p>
                <div class="clean">您现在入住的房间为<span style="color:orange">{{roomId}}</span>房间，最近一次清扫保洁时间为：{{ lastTime }}</div>
              </div>

              <div class="item">
                 <p><i></i>布草更换</p>
                 <el-table :data="roomtableData" border height="90">
                   <el-table-column prop="name" label="种类" width="40">
                     <template slot-scope="{row}">
                       <span v-if="row.name.substring(0, 2) === '56'">枕套</span>
                       <span v-if="row.name.substring(0, 2) === '67'">床单</span>
                       <span v-if="row.name.substring(0, 2) === '78'">被套</span>
                     </template>
                   </el-table-column>
                   <el-table-column prop="name" label="布草ID" width="100">
                   </el-table-column>
                   <el-table-column prop="roomCentralizationTime" label="更换时间">
                     <template slot-scope="{row}">
                       {{flag?row.roomCentralizationTime?`09-28 ${$moment(row.roomCentralizationTime).format('HH:mm')}`:'-':row.roomCentralizationTime?$moment(row.roomCentralizationTime).format('MM-DD HH:mm'):'-'}}
                     </template>
                   </el-table-column>
                 </el-table>
              </div>

              <div class="item" >
                <p><i></i>杯具消毒</p>
                <div class="clean" v-if="logStoolDishclothTime">杯具：<span style="color:#11ab23;margin-right:10px">已消毒</span>消毒时间：{{logStoolDishclothTime?'2023-09-12 10:45:21':''}}</div>
                <div class="clean" v-else>暂无</div>
              </div>
              <div class="item" >
                <p><i></i>洁具清洗</p>
                <div class="clean" v-if="logStoolDishclothTime">洁具：<span style="color:#11ab23;margin-right:10px">已清洁</span>清洁时间：{{logStoolDishclothTime}}</div>
                <div class="clean" v-else>暂无</div>
              </div>
            </div>
         </div>
        </div>
     </div>
 
    </div>
    <div class="tabbar">
      <div class="tab" @click="tabactive=1"> <span class="iconhome" :class="{ 'iconhomeactive':tabactive==1 }"></span> <span class="tabname" :class="{ 'tabnamehome':tabactive==1 }">首页</span></div>
      <div class="tab" @click="tabactive=2"> <span class="iconroom" :class="{ 'iconroomactive':tabactive==2 }"></span> <span class="tabname" :class="{ 'tabnameroom':tabactive==2 }">客房</span></div> 
      <div class="tab" @click="toother"> <span class="iconpool"></span> <span class="tabname" :class="{ 'tabnamepool':tabactive==3 }">泳池</span></div>
    </div>
    <div class="bottom">
     </div>
  </div>
</template>
<script>
import { getData } from '../../api';
export default {
  data(){
    return{
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      tabactive:1,
      hotelId:'0165',
      openbaseInfo:false,
      openHealthSystem:false,
      openDetectionRecords:false,
      openEmployeeInfo:false,
      openbcInfo:false,
      opencupInfo:false,
      openjjInfo:false,
      openroomInfo:false,
      tableData:[
        {
          name:'曾松',
          ep:'楼层经理',
          number:'1102A6089',
          time:"2023-06"
        },
        {
          name:'王星',
          ep:'楼层主管',
          number:'1102A0520',
          time:"2023-03"
        },
         {
          name:'种邱平',
          ep:'楼层主管',
          number:'1102A9993',
          time:"2023-09"
        }
        ,
         {
          name:'班绍涵',
          ep:'实习生',
          number:'1102B4334',
          time:"2023-05"
        },
         {
          name:'晏雨琪',
          ep:'实习生',
          number:'1102B4332',
          time:"2023-05"
        },
         {
          name:'董广荣',
          ep:'楼层服务员',
          number:'1102A230330049',
          time:"2023-05"
        },
         {
          name:'董广芹',
          ep:'楼层服务员',
          number:'1102A230330048',
          time:"2023-05"
        },
         {
          name:'杨正丽',
          ep:'楼层服务员',
          number:'1102A230330052',
          time:"2023-03"
        },
         {
          name:'钱和林',
          ep:'楼层服务员',
          number:'1102A6252',
          time:"2023-07"
        },
         {
          name:'沈佳平',
          ep:'楼层服务员',
          number:'1102A6251',
          time:"2023-07"
        },
         {
          name:'江建明',
          ep:'楼层服务员',
          number:'1102A230904470',
          time:"2023-09"
        },
         {
          name:'庄晓东',
          ep:'楼层服务员',
          number:'1102A230904477',
          time:"2023-09"
        },
         {
          name:'苑永周',
          ep:'楼层服务员',
          number:'1201A21120911106',
          time:"2021-12"
        },
         {
          name:'秦记鱼',
          ep:'楼层服务员',
          number:'1201A21120711081',
          time:"2021-12"
        },
         {
          name:'刘红霞',
          ep:'楼层服务员',
          number:'1102A1028',
          time:"2023-03"
        },
         {
          name:'谢长江',
          ep:'楼层服务员',
          number:'1102A2275',
          time:"2023-04"
        },
        {
          name:'全玉华',
          ep:'楼层服务员',
          number:'1102A2276',
          time:"2023-04"
        }, {
          name:'刘猛',
          ep:'楼层服务员',
          number:'1102A5650',
          time:"2023-06"
        }, {
          name:'谢春玲',
          ep:'楼层服务员',
          number:'1102A5649',
          time:"2023-06"
        },{
          name:'崔浩然',
          ep:'楼层服务员',
          number:'1102A9740',
          time:"2023-09"
        },{
          name:'颜振春',
          ep:'洗衣房经理',
          number:'1102A6332',
          time:"2023-07"
        },
        
      ],
      roomId:'',
      showRoomInfo:false,
      hotelMsg:{},
      roomtableData:[],
      lastTime:'',
      cupsDisinfectTime: '',
      logStoolDishclothTime: '',
    }
  },
  watch: {
    windowHeight (val) {
      let that = this;
      console.log("实时屏幕高度：", val, that.windowHeight);
    },
    windowWidth (val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowHeight);
    }
  },
  created(){
    this.init()
    this.keyboard()
    console.log(this.tabactive);
  },
  mounted () {
    // let vConsole = new this.$Vconsole()
    // console.log(vConsole)
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight;  // 高
        that.windowWidth = window.fullWidth; // 宽
      })()
    };
  },
  methods:{
    keyboard () {

document.body.addEventListener('focusin', () => {
  // 软键盘弹起事件
  this.flag = false
  // console.log(111)
})
document.body.addEventListener('focusout', () => {
  // 软键盘关闭事件
  this.flag = true
  // this.$router.go()
  // console.log(222)
})
},
    // 获取id
    init(){
      this.hotelId = this.getQueryVariable('hotel')
      console.log(this.hotelId);
    },
    // 截取地址字段
      getQueryVariable (variable) {
      if (window.location.search) {
        const arr = window.location.search.split("?")
        var vars = arr[1].split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) { return decodeURIComponent(pair[1]); }
        }
        return (false);
      }
    },
    // a页开关
    openSth(val){
      if (val=='openbaseInfo') {
        this.openbaseInfo =!this.openbaseInfo
        this.openHealthSystem=false
        this.openDetectionRecords=false
        this.openEmployeeInfo=false
      }else if(val=='openHealthSystem'){
       this.openHealthSystem=!this.openHealthSystem
       this.openbaseInfo=false
       this.openDetectionRecords=false
        this.openEmployeeInfo=false
      }else if(val=='openDetectionRecords'){
       this.openDetectionRecords=!this.openDetectionRecords
       this.openbaseInfo=false
       this.openHealthSystem=false
        this.openEmployeeInfo=false
      }else{
        this.openEmployeeInfo=!this.openEmployeeInfo
        this.openbaseInfo=false
       this.openHealthSystem=false
        this.openDetectionRecords=false
      }

      // this.open=!this.open
    },
    // b页开关
    openroomSth(val){
      if (val=='openbcInfo') {
        this.openbcInfo =!this.openbcInfo
        this.opencupInfo=false
        this.openjjInfo=false
        this.openroomInfo=false
      }else if(val=='opencupInfo'){
       this.opencupInfo=!this.opencupInfo
       this.openbcInfo=false
       this.openjjInfo=false
        this.openroomInfo=false
      }else if(val=='openjjInfo'){
       this.openjjInfo=!this.openjjInfo
       this.openbcInfo=false
       this.opencupInfo=false
        this.openroomInfo=false
      }else{
        this.openroomInfo=!this.openroomInfo
        this.openbcInfo=false
       this.opencupInfo=false
        this.openjjInfo=false
      }

      // this.open=!this.open
    },
    getRoomInfo(){
      if (this.roomId!=='') {
        console.log(this.roomId);
        console.log(this.hotelId);
        getData(this.hotelId, this.roomId).then(res=>{
          const { data } = res
        this.hotelMsg = data.hotel
        this.lastTime = data.lastTime ? this.$moment(data.lastTime).format('YYYY-MM-DD') : '暂无'
        this.roomtableData = data.logTextile
        if (data.cups && data.cups.length > 0 && data.cups[0].cupsDisinfectTime) {
          this.cupsDisinfectTime = data.cups[0].cupsDisinfectTime
        }
        this.logStoolDishclothTime = data.logStoolDishclothTime
        })
      
      }
    },
    toother(){
      window.location.href='https://yycswsaq.wsjkw.zj.gov.cn/zjyycsh5/public/detail/818e0c4a-18a7-4eab-9f01-9a3086610781'
    }

  }
}
</script>

<style scoped lang="scss">
// *{
//   margin: 0 auto;
// }
.home{
  width: 100%;
  height: 100vh;
  background-color:#3088f7;
  background-size: 100% 100%;
  position: relative;
  padding-bottom: 150px;
  .top{
      color: #fff;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      padding: 15px 0;
      padding-top: 30px;
    }
    .topbanner{
      width: 100%;
      height: 97px;
      background: url('~@/assets/nb/banner.png') no-repeat;
      background-size: 100%;
    }
 .homeContent{
  padding:0 20px ;
  background-color:#3087f7;
  .indexContent{
    width: 100%;
    background-color: #3087f7;
   .hotelTit{
    position: relative;
    margin-bottom: 15px;
    .titleBar{
    background: url('~@/assets/nb/title.png');
    background-size: 100%;
    height: 36px;
      width: 100%;
      .tit{
        display: block;
        width: 100%;
        font-size: 18px;
      font-weight: bold;
      color: #E5F6FF;
      text-align: center;
      text-shadow: 0px 2px 3px rgba(4,94,211,0.6);
      }
    }
    .activeHealthSystem{
      background: url('~@/assets/nb/hbg.png') no-repeat;
      background-size: 100%;
      width: 100%;
      height: 120%;
      .HealthSystem{
      padding: 30px 25px 12px 25px;
      color: #464B64;
      font-size: 12px;
      .title{
      font-weight: bold;
      }
      .text{
      font-weight: Regular;
      overflow: scroll;
      height: 200px;
      span{
        display: inline-block;
        margin-top: 5px;
      }
    }
    }
    }
    .active{
      background: url('~@/assets/nb/activeTit.png') no-repeat;
      background-size: 100%;
      width: 100%;
      height: 120%;
      .baseInfo{
       padding: 30px 15px 5px 30px;
       font-size: 12px;
       font-weight: 400;
       color: #464B64;
        li{
          margin: 5px 0;
        }
      }
  
    .DetectionRecords{
      padding: 30px 20px 12px 20px;
      .title{
        width: 100%;
        display: flex;
        justify-content: space-around;
        span{
          display: block;
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #464B64;
        }
      }
      .table{
        margin-top: 10px;
        span{
          display: block;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          width: 100%;
          background: linear-gradient(41deg,#b6d5ff, #e6f1ff);
          box-shadow: 0px 2px 4px 0px rgba(36,92,163,0.38);
          border-radius: 7px;
          i{
            display: block;
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #464B64;
            padding: 3px 0;
          }
          .sj{
            width: 30px;
            height: 30px;
            background: url('~@/assets/nb/PDF.png') no-repeat;
            background-size: 100% ;
            background-position: 0 50%;
            position: relative;
            right: 8px;

            &::after{
              content: '';
              position: absolute;
              top: 50%;
              left: 100%;
              transform: translateY(-50%);
            display: inline-block;
            opacity: 0.5;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid #135EFF;
            font-size: 0;
            line-height: 0;
            transform: rotate(90deg);
            }

            
          }
          
        }
      }
    }
    .EmployeeInfo{
      padding:18px 17px 12px 17px;
      .EmployeeInfotop{
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        .box{
          padding: 2px 0;
          width: 30%;
          display: flex;
          flex-direction: column;
          align-content: center;
          background: #FFFFFF;
          box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.3);
          border-radius: 7px;
          .num{
            text-align: center;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #1A7CFA;
            margin-bottom: 3px;
          }
          .title{
            text-align: center;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #464B64;
          }
        }
      }
      ::v-deep.el-table {
      font-size: 12px;
      .el-table__cell {
        padding: 0;
      }
      th.el-table__cell {
        background: rgb(240, 240, 240);
        color: #333;
      }
      .cell {
        padding: 0;
        text-align: center;
      }
    }
    }
    }
    
   }
    
  }

  .roomContent{
    width: 100%;
    // height: 175px;
    background-color: #3087f7;
   .hotelTit{
    position: relative;
    margin-bottom: 15px;
    .titleBar{
    background: url('~@/assets/nb/roomTit.png');
    background-size: contain;
    height: 36px;
      width: 100%;
      .tit{
        display: block;
        width: 100%;
        font-size: 18px;
      font-weight: bold;
      color: #E5F6FF;
      text-align: center;
      text-shadow: 0px 2px 3px rgba(4,94,211,0.6);
      }
    }
    .active{
      background: url('~@/assets/nb/activebc.png') no-repeat;
      background-size: 100%;
      width: 100%;
      height: 100%;
      .bcInfo{
       padding: 15px 25px 5px 25px;
       .bctop{
        width: 100%;
        height: 135px;
        img{
          height: 100%;
        }
       }
       .text{
        margin-top: 9px;
        font-size: 12px;
        font-weight: 400;
        color: #464B64;
        line-height: 16px;
        text-align: justify;
       }
       
      }
     .cupInfo{
      padding: 15px 25px 5px 25px;
      .cuptop{
        width: 100%;
        height: 112px;
        img{
          height: 100%;
        }
       }
       .text{
        margin-top: 9px;
        font-size: 12px;
        font-weight: 400;
        color: #464B64;
        line-height: 16px;
        text-align: justify;
       }
    }
    .jjInfo{
      padding: 15px 25px 5px 25px;
      .jjtop{
        width: 100%;
        height: 91px;
        img{
          height: 100%;
        }
       }
       .text{
        margin-top: 9px;
        font-size: 12px;
        font-weight: 400;
        color: #464B64;
        line-height: 16px;
        text-align: justify;
       }
    
    }
    }
    .activeroomClearn{
      background: url('~@/assets/nb/activebajie.png') no-repeat;
      background-size: 100%;
      width: 100%;
      height: 100%;
      .roomInfo{
        padding: 15px 17px 0 17px;
       .search{
        height: 25px;
        padding: 0 35px;
        display: flex;
        align-items: center;
        justify-content:space-between;
        margin-bottom: 10px;
        .left{
        display: flex;
        align-items: center;
        border-bottom: 1px solid #1492FF;
          span{
          display: block;
          width: 17px;
          height: 17px;
        background: url('~@/assets/nb/search.png') no-repeat;
        background-size: 100% 100%;
        margin-right: 10px;
        }
        input{
          width: 170px;
          border: none;
          outline: none;
          background-color: transparent;
        }
        }
        .right{
          width: 40px;
          height: 20px;
          background: #1492FF;
          box-shadow: 0px 0px 16px 0px rgba(190,204,194,0.3);
          border-radius: 22px;
          color: #fff;
          line-height: 20px;
          text-align: center;
          font-size: 12px;
        }
      

        }
       .item{
        p {
        font-size: 12px;
        display: flex;
        align-items: center;
        margin-left: 4px;
        i {
          display: block;
          width: 5px;
          height: 14px;
          background: #236df5;
          border-radius: 5px;
          margin-right: 4px;
        }
        
      }
      .clean{
        display: block;
        margin: 10px 0;
        padding-left: 13px;
        font-size: 12px;
        font-weight: 400;
        color: #464B64;
      }
      ::v-deep.el-table {
      font-size: 12px;
      .el-table__cell {
        padding: 0;
      }
      th.el-table__cell {
        background: rgb(240, 240, 240);
        color: #333;
      }
      .cell {
        padding: 0;
        text-align: center;
      }
    }
      
      }
      }
    }
   }
    
  }
}
.tabbar{
  z-index: 1;
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  // margin: 0 20px;
  // margin: 0 20px !important;
  display: flex;
  justify-content: space-evenly;
  background-color:#4795fa;
  // background-color:rgba(255, 255, 255, 0.192);
  border-radius: 5px;
  font-size: 16px;
  padding: 8px 0;
  color: #CACACA;
  .tab{
    display: flex;
    flex-direction: column;
    justify-content: center;
  .tabname{
    display: block;
    margin-top: 5px;
  }
  .tabnamehome{
    color: #fff;
  }
  .tabnameroom{
    color: #fff;
  }
  .tabnamepool{
    color: #fff;
  }
  .iconhome{
    display: block;
    background: url('~@/assets/nb/home.png') no-repeat;
    width: 36px;
    height: 36px;
    background-size: 17px 19px;
    background-position: 50% 50%;
  }
  .iconhomeactive{
    display: block;
    background: url('~@/assets/nb/activeHome.png') no-repeat;
    width: 36px;
    height: 36px;
    background-size:100%;
  }
  .iconroom{
    display: block;
    background: url('~@/assets/nb/room.png')no-repeat;
    width: 36px;
    height: 36px;
    background-size: 20px 14px;
    background-position: 50% 50%;
  } 
  .iconroomactive{
    display: block;
    background: url('~@/assets/nb/activeRoom.png') no-repeat;
    width: 36px;
    height: 36px;
    background-size: 100%;
  }
  .iconpool{
    display: block;
    background: url('~@/assets/nb/pool.png') no-repeat;
    width: 36px;
    height: 36px;
    background-size: 20px 14px;
    background-position: 50% 50%;
  }
  }

}
.bottom{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: url('~@/assets/nb/bbanner.png') no-repeat;
  background-size: contain;
}
}

</style>
